<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <ArenaEventForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaEventForm from '@/components/settings/app-frotix-registers/arenaevent/ArenaEventForm'

export default {
  name: 'ArenaEventAddView',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaEventForm
  }
}
</script>
